import { MemberLimitSchema } from "./MemberLimit";
import { inviteApprovalTypeZod } from "./InviteApprovalType";
import { NotificationRangeZod } from "./NotificationRange";
import { z } from "zod";
import { GroupMemberSchema } from "./GroupMember";

export type GroupProfile = z.infer<typeof GroupProfileSchema>;
export const GroupProfileSchema = z.object({
  id: z.string(),
  name: z.string(),
  icon: z.string(),
  qr: z.string(),
  description: z.string(),
  memberLimitInfo: MemberLimitSchema,
  // members: z.array(QcConversationMemberSchema),
  members: z.array(GroupMemberSchema),
  inviteApprovalType: inviteApprovalTypeZod,
  notificationRange: NotificationRangeZod,
  is_anonymous_join: z.boolean(),
});
